<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="评价期" prop="appraisePeriodList">
                    <el-select v-model="queryCondition.appraisePeriodList" multiple clearable placeholder="请选择(支持多选)" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in allDate" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Facility名称" prop="facilityName">
                      <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2CodeList">
                      <el-select v-model="queryCondition.category2CodeList" @change="changeCategory2" multiple  clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3CodeList">
                      <el-select v-model="queryCondition.category3CodeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                         <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="供应商集团名称" prop="supplierGroupName">
                      <el-input v-model="queryCondition.supplierGroupName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button  size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="QSPI_AAA_GEN_TASK" size="mini" class="btn" type="primary" @click="onCreate">发起评分任务</el-button>
        <el-button v-acl="QSPI_AAA_DEL_TASK" :disabled="multipleSelection.length>0?false:true" size="mini" class="btn" type="danger" @click="onDel">删除</el-button>
        <el-button v-if="statusView=='C'||statusView=='OC'" size="mini" class="btn" :disabled="multipleSelection.length>0?false:true" type="primary" @click="setRejectExpireDate">设置整改截止日期</el-button>
        <el-date-picker v-if="statusView=='C'||statusView=='OC'" v-model="rejectExpireDate" value-format="yyyy-MM-dd" type="date" placeholder="请输入日期"> </el-date-picker>

      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="评价期" field="appraisePeriod"  width="120" />
        <ux-table-column align="center" title="Category2" min-width="100" field="category2Name"></ux-table-column>
        <ux-table-column align="center" title="Facility编号" min-width="120" field="facilityCode"></ux-table-column>
        <ux-table-column align="center" title="Facility名称" min-width="140" field="facilityName"></ux-table-column>
        <ux-table-column align="center" title="状态" min-width="100" field="statusView"></ux-table-column>
        <ux-table-column align="center" title="截止日期" min-width="120" field="closingDate"></ux-table-column>
        <ux-table-column align="center" title="评分" min-width="100" field="updateDate">
          <template v-slot="scope">
            <el-button type="text" @click="onGrade(scope.row)">评分</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="整改" min-width="100" field="updator">
          <template v-slot="scope">
            <el-button type="text" @click="onAbarbeitung(scope.row)">整改</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="创建日期" min-width="120" field="createDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog" :formData="formData"></detailDialog>
    </el-dialog> -->
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import ratingTask from "@/api/AAA/ratingTask.js";
import QBRApi from "@/api/QBR/index";
import apiService  from "@/api/AAA/index.js";
import commonFunction from "@/utils/dataTableUtils";


export default {
  name: '',
  components: {
    IcSelect,
    // detailDialog
  },
  data() {
    return {
      rejectExpireDate:"",
      identity:localStorage.getItem('ms_emplFlag'),
      allDate:[],
      multipleSelection:[],
      categoryList2: [],
      categoryList3: [],
      statusList: [],
      queryCondition: {
        appraisePeriodList: [],
        category2CodeList: [],
        category3CodeList: [],
        facilityName: "",
        pageNum: 1,
        pageSize: 15,
        status: "",
        supplierGroupName: ""
      },
      isShow: false,
      showDetailDialog:false,
      tableData: [],
      formData:null,
      totalCount:"",
      statusView:"",
      rulesList:localStorage.getItem('ms_roles'),
    }
  },
  created() {
    this.getAllDate()
    this.getCategory2Lists()
    this.getCategory3Lists()
    this.getStatusList()
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    if (this.identity=='SUP') {   //判断是供应商
      this.statusView = 'S';
    }else {
      if(this.rulesList.indexOf('QSPI_AAA_CQS')!=-1&&this.rulesList.indexOf('QSPI_AAA_OWNER')!=-1){
        this.statusView = 'OC';
      }else{
        if(this.rulesList.indexOf("QSPI_AAA_ADMIN")!=-1){       //判断是否是ADMIN
          this.statusView = 'A';
        }else{
          for (let i = 0, len = permission.length; i < len; i++) {
            if (permission[i] == 'QSPI_AAA_OWNER') {
              this.statusView = 'O';
              return
            }else{
              this.statusView = 'C';
            }
          }
        }
      }
    }
    console.log("statusView",this.statusView)
    // this.queryData();
  },
  mounted(){
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      ratingTask.getApageList(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.totalCount=res.totalCount
      })
    },
    onDetail(row){
      this.showDetailDialog=true
      this.formData=JSON.stringify(row)
    },
    onGrade(row){
      console.log("rowroworwor===",row)
      sessionStorage.setItem("taskDetail",JSON.stringify(row))
      this.$router.push({
        path:"/aaaMarkSheet",
        query:{
          id:row.ttQspiAaaScoreId
        }
      })
    },
    onAbarbeitung(row){
      sessionStorage.setItem("taskDetail",JSON.stringify(row))
      this.$router.push({
        path:"/sponsormarkSheet",
        query:{
          id:row.ttQspiAaaScoreId
        }
      })
    },
    onReset() {
      this.queryCondition={
        appraisePeriodList: [],
        category2CodeList: [],
        category3CodeList: [],
        facilityName: "",
        pageNum: 1,
        pageSize: 15,
        status: "",
        supplierGroupName: ""
      }
      this.queryCondition.pageNum=1
      let defaultVal=this.allDate.filter((a)=>{return a.isDefault})
      if(defaultVal.length>0){
        this.queryCondition.appraisePeriodList.push(defaultVal[0].code)
      }
      this.queryData();
    },
    onCreate() {
      this.$router.push({
        path:"/initiateGrade",
        query:{

        }
      })
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onDel() {
      let isCreate=this.multipleSelection.some((v)=>{
        return !v.isCanAudit
      })
      if(isCreate){ 
        this.$message.error('您无权限操作数据')
      }else{
        let arr=[]
        this.multipleSelection.forEach((v)=>{
          arr.push(v.ttQspiAaaScoreId)
        })
        ratingTask.deleteBatch(arr).then((res)=>{
          if(res.code==200){
            this.$message.success('删除成功')
            this.queryData()
          }else{
            this.$message.error(res.msg)
          }
        })
      }
    },
    setRejectExpireDate(){
      let isCreate=this.multipleSelection.some((v)=>{
        return v.status!=5
      })
      if(isCreate){
        this.$message.error("仅状态为待整改的评分任务可设置，请检查")
      }else{
        let isCanAudit=this.multipleSelection.some((v)=>{
          return !v.isCanAudit
        })
        if(isCanAudit){ 
          this.$message.error('您无权限操作数据')
        }else{
          let params={
            idList:[],
            rejectExpireDate:this.rejectExpireDate+' 23:59:59',
          }
          this.multipleSelection.forEach((v)=>{
            params.idList.push(v.ttQspiAaaScoreId)
          })
          ratingTask.setExpire(params).then((res)=>{
            if(res.code==200){
              this.$message.success('设置成功')
              this.queryData()
            }else{
              this.$message.error(res.msg)
            }
          })
        }
      }
    },
    selectionChange(val){
      this.multipleSelection=val
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.queryCondition.category2CodesList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
    getStatusList(){
      apiService.getAaaStatus().then((res)=>{
        this.statusList=res.resultData
      })
    },
    getAllDate(){
      apiService.getAllDate().then((res)=>{
        let defaultVal=res.resultData.filter((a)=>{return a.isDefault})
        if(defaultVal.length>0){
          this.queryCondition.appraisePeriodList.push(defaultVal[0].code)
        }
        this.allDate=res.resultData
        this.queryData()
      })
    },
    
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
